import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlComponent } from './form-control.component';
import { FormErrorComponent } from './form-error.component';
import { ReactiveFormsModule } from '@angular/forms';
import { UiComponentsModule } from '@shared/ui-components';

@NgModule({
	declarations: [FormControlComponent, FormErrorComponent],
	exports: [FormControlComponent, FormErrorComponent],
	imports: [CommonModule, UiComponentsModule,  ReactiveFormsModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormControlModule { }
